import { BreakpointProvider, SWAThemeProvider } from '@jetstream/themes';
import './index.scss';

const Unauthorized = () => {
  function logOut() {
    window.localStorage.clear();
    window.sessionStorage.clear();
    window.cookie = '';
    window.location.assign(process.env.REACT_APP_LOGOUT_URI);
  }

  return (
    <BreakpointProvider>
      <SWAThemeProvider>
        <div className="unauthorized-page">
          <div>You are not authorized to view this page.</div>
          <button onClick={() => logOut()} className="logout-button">
            Logout here...
          </button>
        </div>
      </SWAThemeProvider>
    </BreakpointProvider>
  );
};

export default Unauthorized;
